export const BACKEND_ROOT_DIR = 'asset_manager_file_system'

export function toBackendPath(filepath: string): string {
  return `${BACKEND_ROOT_DIR}/${filepath}`
}
